import React from "react";
import "./CoursesHelpSection.css";
import rightImage from "../Assets/Courses-help.png"; 

const CoursesHelpSection = () => {
  return (
    <section className="chs-section-unique">
      <div className="chs-container-unique">
        {/* Left Content */}
        <div className="chs-text-unique">
          <h2 className="chs-title-unique"> Courses Designed for Student Success</h2>
          <p className="chs-description-unique">
            The student path comes with lots of hurdles. To tackle exams, public
            speaking and applying to global programs, we built NewZeal Language Academy.
            We mix academic learning with real-world communication skills in our
            curriculum.
          </p>
          <ul className="chs-list-unique">
            <li>
              For School & College Students: Strengthen your grammar, expand your vocabulary, and practice fluent speaking to excel in academics, activities, and everyday communication.
            </li>
            <li>
              For Competitive Tests: Build the English skills needed to succeed in entrance exams, group discussions, and interviews with focused training and guidance.
            </li>
            <li>
              To Study Abroad: Prepare for global opportunities by developing the English proficiency required for TOEFL, IELTS, and other international standards — giving you the confidence to apply and succeed.
            </li>
          </ul>
          <p className="chs-footer-unique">
            We provide a supportive space to speak English using hands-on
            lessons, group practice, and detailed suggestions tailored for you.
          </p>
        </div>

        {/* Right Image */}
        <div className="chs-image-unique">
          <img src={rightImage} alt="Students studying" />
        </div>
      </div>
    </section>
  );
};

export default CoursesHelpSection;
